<template>
  <div>
    <Navbar :center-text="$t('HomeView.homepage')"
            :message="this.message"
            :message-type="this.messageType"></Navbar>
    <div class="container my-4">
      <img src="../assets/agreco_header.png"
           alt=""
           class="img-fluid w-75"/>
      <TopicSectionComponent v-for="section in sections"
                     :topic-cards="section.cards"
                     :section-title="section.title">
      </TopicSectionComponent>
    </div>
    <Footerbar></Footerbar>
  </div>
</template>


<script>
import Navbar from "@/components/Navbar.vue";
import {sharedState} from "@/store";
import Footerbar from "@/components/Footerbar.vue";
import TopicSectionComponent from "@/views/TopicSectionComponent.vue";

export default {
  data() {
    return {
      sharedState,
      message: null,
      messageType: null,
    };
  },
  components: {
    TopicSectionComponent,
    Footerbar,
    Navbar,
  },
  async created() {
    if (this.sharedState.user_id === null) {
      this.$router.push({name: "login"});
    }
  },
  computed: {
    sections() {
      return [
        {
          'title': this.$t('HomeView.advisoryActivities'),
          'cards': [
            {
              'isEnabled': true,
              'title': this.$t('AdvisoryActivitiesView.reportingActivities'),
              'text': this.$t('AdvisoryActivitiesView.reportingActivitiesDescription'),
              'buttonText': this.$t('TopicCardComponent.letsReport'),
              'link': 'advice',
              'icon': 'bi-chat-text',
            },
            {
              'isEnabled': true,
              'title': this.$t('DiagnosticsSearchView.agroecologicalDiagnostics'),
              'text': this.$t('DiagnosticsSearchView.diagnosticsDescription'),
              'buttonText': this.$t('TopicCardComponent.letsAssess'),
              'link': 'diagnostics',
              'icon': 'bi-clipboard-pulse',
            },
          ]
        },
        {
          'title': this.$t('HomeView.learning'),
          'cards': [
            {
              'isEnabled': true,
              'title': this.$t('TrainingResourcesView.trainingResources'),
              'text': this.$t('TrainingResourcesView.trainingResourcesDescription'),
              'buttonText': this.$t('TopicCardComponent.seeResources'),
              'link': 'training',
              'icon': 'bi-book',
            },
            {
              'isEnabled': true,
              'title': this.$t('SuccessStoriesView.successStories'),
              'text': this.$t('SuccessStoriesView.successStoriesDescription'),
              'buttonText': this.$t('TopicCardComponent.seeStories'),
              'link': 'success',
              'icon': 'bi-trophy'
            }
          ]
        },
        {
          'title': this.$t('HomeView.collaboration'),
          'cards': [
            {
              'isEnabled': true,
              'title': this.$t('CollaborationView.collaboration'),
              'text': this.$t('CollaborationView.collaborationDescription'),
              'buttonText': this.$t('TopicCardComponent.letsCollaborate'),
              'link': 'collaboration',
              'icon': 'bi-globe-europe-africa'
            },
            {
              'isEnabled': true,
              'title': this.$t('TemplatesView.templates'),
              'text': this.$t('TemplatesView.templatesDescription'),
              'buttonText': this.$t('TopicCardComponent.letsShare'),
              'link': 'templates',
              'icon': 'bi-file-earmark-check'
            },
          ]
        },
        {
          'title': this.$t('HomeView.dataManagement'),
          'cards': [
            {
              'isEnabled': false,
              'title': this.$t('HomeView.appointments'),
              'text': '',
              'buttonText': '',
              'link': '',
            },
            {
              'isEnabled': false,
              'title': this.$t('HomeView.routeOptimization'),
              'text': '',
              'buttonText': '',
              'link': '',
            },
            {
              'isEnabled': false,
              'title': this.$t('HomeView.dataCorrection'),
              'text': '',
              'buttonText': '',
              'link': '',
            }
          ]
        },
      ]
    }
  },
};
</script>
